<template>
  <div
    class="bb-loader-select"
    v-click-outside="closeDropdownMenu"
    @mouseleave="closeDropdownMenu; setDisplayPopup($event, false)"
  >
    <div class="bb-loader-select-header"
         :class="{
           'bb-loader-select-header_error': error,
           'bb-loader-select-header_view-mode': viewMode
         }"
         ref="bbSelectHeader"
         @click="openDropdownMenu">
      <div
        v-if="!isSelectUserFilter"
        class="bb-loader-select-header-selected"
      >
          <span class="bb-loader-select-header-selected__value"
                @click.stop="clickBySelect"
                :class="{
                  'bb-loader-select-header-selected__value_tag': type === 'tag',
                  'bb-loader-select-dropdown-menu-item_yellow': value.color === 'yellow',
                  'bb-loader-select-dropdown-menu-item_green': value.color === 'green',
                  'bb-loader-select-dropdown-menu-item_red': value.color === 'red',
                  }"
                v-if="selectedValue || selectedValue === 0"
          >
            <i class="bb-loader-select-dropdown-menu-item__icon"
               :class="['icon-' + value.icon]"
               v-if="value.icon"/>
            <img
              class="bb-loader-select-img"
              :src="viewMode || updatedInEditMode ? getValueImage(value) : iconAddCompany"
              @mouseenter="setDisplayPopup($event, true)"
              @mouseleave="setDisplayPopup($event, false)"
            />
            <transition name="bounce">
              <div
                v-if="hoverImage && viewMode"
                :style="popupPosition"
                ref="popup"
                class="bb-loader-select-img-popup"
              >
                {{value.username}}
              </div>
            </transition>
            <i class="icon-cross bb-loader-select-header-selected__remove"
               v-if="clearable"
               @click.stop="removeValue()"/>
          </span>
        <span class="bb-loader-select-header-selected__placeholder" v-else>
          {{placeholder || ''}}
        </span>
      </div>
      <input
        v-if="searchable"
        class="bb-loader-select-header__search"
        type="text"
        @blur="clearInput"
      />
    </div>
    <transition name="slide-select">
      <div>
        <VuePerfectScrollbar class="bb-loader-select-dropdown-menu"
                             :class="{'bb-loader-select-dropdown-menu_tag': type === 'tag',
                                      'bb-loader-select-dropdown-menu_width': minWidth
                                     }"
                             :settings="scrollSettings"
                             ref="bbSelectDropdownMenu"
                             v-show="displayDropdownMenu"
                             @mouseleave="closeDropdownMenu"
        >
          <div class="bb-loader-select-dropdown-menu__empty bb-loader-select-dropdown-menu__empty_top">
          </div>
          <div
            v-if="!isHideSearch"
            class="bb-loader-select-dropdown-menu-search"
          >
            <input
              class="bb-loader-select-dropdown-menu-search__input"
              type="text"
              placeholder="Search"
              @input="searchValueInput" />
          </div>
          <div class="bb-loader-select-dropdown-menu-item"
               :class="{
               'bb-loader-select-dropdown-menu-item_tag': type === 'tag',
               'bb-loader-select-dropdown-menu-item_tag_selected': type === 'tag' && isSelected(option),
               'bb-loader-select-dropdown-menu-item_selected': !isSelectUserFilter && isSelected(option),
               'bb-loader-select-dropdown-menu-item_selected-no-pointer': isSelectUserFilter && isSelected(option),
               'bb-loader-select-dropdown-menu-item_yellow': option.color === 'yellow',
               'bb-loader-select-dropdown-menu-item_green': option.color === 'green',
               'bb-loader-select-dropdown-menu-item_red': option.color === 'red',
               'bb-loader-select-dropdown-menu-item_last-item': index === optionsSorted.length - 1,
             }"
               v-for="(option, index) in optionsSorted"
               :key="option.id"
               @click="setValue(option)">
            <i
              v-if="option.icon"
              class="bb-loader-select-dropdown-menu-item__icon"
              :class="['icon-' + option.icon]"
            />
            <img
              v-if="!hideImage"
              class="bb-loader-select-img"
              :class="[
                isSelectUserFilter && isSelected(option) && 'bb-loader-select-img_selected'
              ]"
              :src="option.image ? option.image.path : avatarUserDefault"
            />
            {{option[label]}}
            <div
              v-if="isSelectUserFilter && isSelected(option)"
              class="bb-loader-select-dropdown-menu-item__check"
              v-html="okIcon()"
            />
          </div>
          <div class="bb-loader-select-dropdown-menu__empty bb-loader-select-dropdown-menu__empty_bot"/>
        </VuePerfectScrollbar>
      </div>
    </transition>
  </div>
</template>

<script>
import {get, orderBy} from 'lodash'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import avatarUserDefault from '@/assets/images/avatar-user-default.png'
import iconAddCompany from '@/assets/images/icon-add-company.png'
import {OK_ICON} from '@/constants/icons'

export default {
  name: 'BBPSelectImage',
  components: {
    VuePerfectScrollbar
  },
  props: [
    'model',
    'searchable',
    'clearable',
    'options',
    'label',
    'value',
    'isSelectUserFilter',
    'disabled',
    'minWidth',
    'maxHeight',
    'multiple',
    'placeholder',
    'orderBy',
    'error',
    'type',
    'item',
    'hideImage',
    'viewMode',
    'scrollTop',
    'isOpen',
    'isNoMouseClose',
    'search',
    'isHideSearch',
    'position',
    'maxHeightPopup'
  ],
  data () {
    return {
      displayDropdownMenu: false,
      avatarUserDefault: avatarUserDefault,
      iconAddCompany: iconAddCompany,
      updatedInEditMode: false,
      scrollSettings: {
        wheelPropagation: false
      },
      searchValue: '',
      hoverImage: false,
      popupPosition: {},
      okIcon: OK_ICON
    }
  },
  computed: {
    optionsSorted () {
      const keys = get(this.orderBy, 'keys', [])
      const order = get(this.orderBy, 'order', [])
      return orderBy(this.searchValue ? this.options.filter(el => el[this.label].startsWith(this.searchValue))
        : this.options, [...keys], [...order])
    },
    selectedValue () {
      return get(this.value, this.label, '')
    }
  },
  methods: {
    isSelected (option) {
      if (!this.value) return
      const { id, _id } = this.value
      if (id) return id === option.id
      if (_id) return _id === option._id
    },
    getValueImage (value) {
      const { image } = value
      return image ? image.path : avatarUserDefault
    },
    searchValueInput (e) {
      this.searchValue = e.target.value.toLowerCase()
    },
    setValue (value) {
      if (this.isSelectUserFilter && this.value) {
        const { id, _id } = this.value
        if (id === value.id) {
          this.$emit('change', value)
        } else if (_id === value._id) {
          this.$emit('change', value)
        }
        return
      }
      this.updatedInEditMode = true
      this.closeDropdownMenu()
      this.$emit('change', value, this.item)
    },
    clickBySelect () {
      if (!this.value.popup) {
        this.openDropdownMenu()
      }
      this.$emit('clickBySelected', this.value)
    },
    closeDropdownMenu () {
      if (this.isNoMouseClose) return
      this.displayDropdownMenu = false
      this.searchValue = ''
      this.$emit('update:isOpen', false)
    },
    openDropdownMenu () {
      if (this.viewMode) return
      this.calcFixedPosition()
      this.displayDropdownMenu = !this.displayDropdownMenu
    },
    clearInput (e) {
      e.target.value = ''
    },
    removeValue () {
      this.setValue('')
    },
    setFixedPosition ({top, bottom, left, right, width, height}) {
      const dropdownMenuSelect = get(this.$refs, 'bbSelectDropdownMenu.$el', '')
      if (!dropdownMenuSelect) return
      dropdownMenuSelect.style.position = 'fixed'
      dropdownMenuSelect.style.top = top ? top + height + 'px' : ''
      dropdownMenuSelect.style.bottom = bottom ? bottom + height + 'px' : ''
      dropdownMenuSelect.style.left = left ? left + 'px' : ''
      dropdownMenuSelect.style.right = right ? right + 'px' : ''
      dropdownMenuSelect.style.width = width + 'px'
      if (this.position) {
        dropdownMenuSelect.style.top = this.position.top
        dropdownMenuSelect.style.left = this.position.left
        dropdownMenuSelect.style.bottom = ''
      }
    },
    calcFixedPosition () {
      const headerSelect = get(this.$refs, 'bbSelectHeader', '')
      if (!headerSelect) return
      const heightPopup = this.calcHeightPopup()
      const { left: hLeft, top: hTop } = headerSelect.getBoundingClientRect()
      const { innerWidth, innerHeight } = window
      const widthPopup = 350
      const width = headerSelect.offsetWidth
      const height = headerSelect.offsetHeight + 8
      const left = innerWidth - widthPopup > hLeft ? hLeft : undefined
      const right = innerWidth - widthPopup > hLeft ? undefined : 40
      const top = innerHeight - heightPopup < hTop ? undefined : hTop
      const bottom = innerHeight - heightPopup < hTop ? 30 : undefined
      this.setFixedPosition({top, bottom, left, right, width, height})
    },
    calcHeightPopup () {
      const maxHeightPopup = this.maxHeightPopup || 280
      const inputHeight = 54
      const item = this.hideImage ? 27 : 40
      const height = (this.options.length * item) + inputHeight + 50
      return height > maxHeightPopup ? maxHeightPopup : height
    },
    setDisplayPopup (e, val) {
      this.hoverImage = val
      const position = e.target.getBoundingClientRect()
      if (val && position) {
        this.$nextTick(() => {
          if (!this.$refs.popup) return
          const popupPosition = this.$refs.popup.getBoundingClientRect()
          const { left, width } = position
          this.popupPosition = {
            position: 'absolute',
            'margin-top': '4px',
            left: `${(left + (width / 2) - popupPosition.x) + 9}px`
          }
        })
      } else {
        this.popupPosition = {}
      }
    }
  },
  watch: {
    displayDropdownMenu () {
      this.$emit('dropdownOpen', this.displayDropdownMenu)
    },
    isOpen (newVal) {
      if (!newVal) return
      this.calcFixedPosition()
      this.displayDropdownMenu = true
    },
    search (newVal) {
      this.searchValue = newVal
    }
  },
  mounted () {
    if (this.isOpen) {
      this.calcFixedPosition()
      this.displayDropdownMenu = true
    }

    window.addEventListener('resize', this.closeDropdownMenu, false)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.closeDropdownMenu, false)
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bb-loader-select {
  @include global-font;
  font-weight: 500;
  font-size: inherit;
  height: 100%;
  width: 100%;

  &-img {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    margin-right: 8px;

    &_selected {
      border: 2px solid $color-denim;
    }

    &-popup {
      position: absolute;
      left: auto;
      top: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      padding: 4px 7px;
      background: rgba($color-black, 0.55);
      font-weight: 500;
      font-size: 11px;
      line-height: 13px;
      text-align: center;
      color: $color-white;
      border-radius: 3px;
      z-index: 20;
      pointer-events: all;
      text-transform: capitalize;

      &:before {
        content: '';
        position: absolute;
        left: auto;
        top: -3px;
        display: block;
        width: 0;
        height: 0;
        border-left: 3px solid transparent;
        border-right: 3px solid transparent;
        border-bottom: 3px solid rgba($color-black, 0.55);;
      }
    }
  }

  &-header {
    display: inline-flex;
    align-items: center;
    height: 100%;
    position: relative;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 5px 8px;
    cursor: pointer;

    &_view-mode {
      border-color: transparent;
      cursor: default;
      margin-left: -10px;
    }

    &_error {
      border-color: $color-red-orange;
      transition: 0.3s;
    }

    &-selected {
      display: inline-flex;

      &__placeholder {
        color: $color-silver;
        pointer-events: none;
        user-select: none;
      }

      &__value {
        display: flex;
        align-items: center;
        padding: 2px;
        border-radius: 3px;

        &_tag {
          color: $color-accent;
          background: rgba($color-accent, 0.2);
        }
      }

      &__remove {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 15px;
        height: 15px;
        margin: -3px -3px -3px 1px;
        font-size: 12px;
        color: rgba($color-accent, 0.5);
        cursor: pointer;
        transition: 0.4s;

        &:hover {
          color: rgba($color-accent-hover, 0.5);
        }
      }
    }

    &__arrow {
      position: absolute;
      right: 9px;
      color: $color-accent;
      font-size: 5px;
      transition: 0.3s ease;

      &_active {
        transform: rotate(180deg);
      }
    }

    &__search {
      position: absolute;
      width: calc(100% - 25px);
      height: calc(100% - 2px);
      top: 1px;
      left: 1px;
      padding: 5px 0 5px 15px;
      opacity: 0;
      border-radius: 5px;
      border: none;

      &:focus {
        opacity: 1;
      }
    }
  }

  &-dropdown-menu {
    overflow: hidden;
    display: grid;
    //display: grid !important;
    align-items: center;
    position: relative;
    width: 100%;
    min-width: 280px;
    background: $color-white;
    box-shadow: 0 0 12px rgba($color-black, 0.12);
    border-radius: 5px;
    padding-left: 16px;
    color: $color-black;
    z-index: 1000;
    max-height: 350px;
    transform: translateX(-16px);

    &_width {
      min-width: 82px;
    }

    &_tag {
      display: inline-flex;
      flex-wrap: wrap;
      color: $color-accent;
    }

    &__empty {
      position: sticky;
      width: 100%;
      height: 8px;
      background-color: $color-white;
      margin-right: 8px;
      z-index: 1;

      &_top {
        top: 0;
        margin-bottom: -8px;
      }

      &_bot {
        bottom: 0;
      }
    }

    &-search {
      position: sticky;
      top: 0;
      background-color: $color-white;
      margin-right: 16px;
      z-index: 9999;

      &__input {
        align-self: center;
        margin: 16px 0px 4px 0;
        line-height: calc(100% + 1px);
        height: 34px;
        border-radius: 4px;
        border: 1px solid $color-mercury;
        background: url("~@/assets/images/search.png") no-repeat 12px 9px;
        background-color: $color-white;
        padding-left: 36px;
        width: 100%;
      }
    }

    &-item {
      display: inline-flex;
      align-items: center;
      align-self: center;
      border-radius: 3px;
      margin: 12px 16px 0 0;
      transition: 0.3s;
      line-height: calc(100% + 1px);
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      text-transform: capitalize;

      &_last-item {
        padding-bottom: 10px;
      }

      &_selected {
        pointer-events: none;
        color: $color-accent;
        font-weight: 600;
      }

      &_selected-no-pointer {
        color: $color-accent;
      }

      &:hover {
        opacity: 0.8;
        color: $color-accent-hover;
      }

      &_yellow {
        color: $color-la-rioja;
        &:hover {
          opacity: 0.8;
          color: $color-la-rioja;
        }
      }

      &_green {
        color: $color-japanese-laurel;
        &:hover {
          opacity: 0.8;
          color: $color-japanese-laurel;
        }
      }

      &_red {
        color: $color-pomegranate;
        &:hover {
          opacity: 0.8;
          color: $color-pomegranate;
        }
      }

      &_tag {
        background: rgba($color-accent, 0.2);

        &_selected {
          background: rgba($color-silver-chalice, 0.2);
          color: $color-silver-chalice;
        }

        &:hover {
          background: rgba($color-accent-hover, 0.2);
        }
      }

      &__icon {
        font-size: 13px;
        margin-right: 6px;

        &:before {
          margin: 0;
        }
      }

      &__check {
        position: absolute;
        right: 20px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/InputFields/BBPSelectImage/BBPSelectImage.vue